import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';

import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import Pagination from '@material-ui/lab/Pagination';

import {
    Grid,
    Typography,
    withStyles
} from "@material-ui/core";

import {IconButton, MuiThemeProvider} from "material-ui";

import Select from "../../components/Select";

import Http from "../../Http";
import {WHITELIST_ROUTES} from "../../config/routes";
import TableHead from "@material-ui/core/TableHead";
import EditIcon from "@material-ui/icons/Edit";
import {onlyUnique, superSplit} from "../../utils/functions";
import ChangeWhitelistPopup from "./ChangeWhitelistPopup";


const StyledTableRow = withStyles((theme) => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.action.hover,
        // },
        '&:hover': {
            cursor: 'pointer'
        }
    },
}))(TableRow);

function EnhancedTableHead() {
    return (
        <TableHead>
            <StyledTableRow>
                <TableCell align={'center'}>{'Сайт'}</TableCell>
                <TableCell align={'center'}>{'Кол-во ID мужчин'}</TableCell>
                <TableCell align={'center'}>{'Изменить'}</TableCell>
            </StyledTableRow>
        </TableHead>
    );
}

const styles = theme => ({
    root: {
        width: '100%',

    },
    sec: {
        color: theme.palette.secondary.main
    },
    prim: {
        color: theme.palette.primary.main
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    button: {
        color: '#fff',
        marginLeft: '10px',
        marginBottom: '10px',
        width: '200px'
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    },
    disabledSwitch: {}
});

class Whitelist extends React.Component {

    constructor(props) {
        super(props);


        this.state = {
            rowPerPage: 10,
            page: 1,
            isOpenIdsPopup: false,
            changedSiteId: null,
            changedIds: null,
            data: [],
        }

    }

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage});
    };

    handleChangeIds = (text) => {
        this.setState({changedIds: text})
    }


    saveIds = () => {
        Http.post(WHITELIST_ROUTES.updateWhitelists, {site_id: this.state.changedSiteId, ids: superSplit(this.state.changedIds).join(' ')}).then(data => {
            this.setState({data: data.data, changedSiteId: null, isOpenIdsPopup: false})
        })
    }

    handleChangeRowsPerPage = (event) => {
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        this.setState({
            rowPerPage: event,
            page: 1
        })
    };


    getSliced = (clients) => {
        const {rowPerPage, page} = this.state;
        return rowPerPage !== 'ВСЕ' ? clients.slice((page - 1) * rowPerPage, (page - 1) * rowPerPage + rowPerPage) : clients
    }

    getWhitelists(type = 'common', clientId = null) {


        Http.get(WHITELIST_ROUTES.getWhitelists).then(data => {
            this.setState({data: data.data})
        })

    }


    componentDidMount() {
        this.getWhitelists();
    }

    render() {
        const {rowPerPage, page, data, changedSiteId} = this.state;
        const {classes} = this.props;

        let statData = this.getSliced(data);
        return (
            <div className={classes.root}>
                <Typography
                    component={'div'}
                    style={{marginBottom: '30px', fontSize: '2rem'}}
                >
                    Рекомендации агенства
                </Typography>
                <Typography
                    component={'div'}
                    style={{marginBottom: '30px', fontSize: '1rem'}}
                >
                    Мужчины из списка "Рекомендации агентства" не исключаются из рассылки по "Онлайн" и другим спискам.
                    Для исключения мужчин из рассылки добавьте их в <b>"Blacklist"</b>
                </Typography>

                <Paper component={'div'} className={classes.paper}>

                    <TableContainer>
                        <Table
                            stickyHeader
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={'asc'}
                                orderBy={'id'}
                                page={page}
                                rowCount={statData.length}
                            />

                            <TableBody>
                                {statData
                                    .map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <>
                                                <StyledTableRow
                                                    tabIndex={-1}
                                                    key={row.login}
                                                >
                                                    <MuiThemeProvider>

                                                        <TableCell component="th" id={labelId} scope="row"
                                                                   align="center">
                                                            {row.alias}
                                                        </TableCell>
                                                        <TableCell component="th" id={labelId} scope="row"
                                                                   align="center">
                                                            {row.whitelists ? (superSplit(row.whitelists[0]?.ids || '').length || 0) : 0}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <IconButton onClick={() => this.setState({
                                                                isOpenIdsPopup: true,
                                                                changedSiteId: row.id,
                                                                changedIds: data[data.findIndex(obj => obj.id === row.id)]?.whitelists[0] ? superSplit(data[data.findIndex(obj => obj.id ===  row.id)].whitelists[0].ids).filter(onlyUnique).join(' ') : ''})}
                                                            >
                                                                <EditIcon color={'primary'}/>
                                                            </IconButton>
                                                        </TableCell>

                                                    </MuiThemeProvider>

                                                </StyledTableRow>

                                            </>
                                        );
                                    })}

                            </TableBody>

                        </Table>
                    </TableContainer>

                </Paper>
                <Grid container>
                    <Grid item xs={7} sm={7} md={7} lg={7}></Grid>
                    <Grid item xs={5} sm={5} md={5} lg={5} style={{
                        display: 'flex',
                        aligItems: 'center',
                        fontSize: '11px',
                        alignItems: 'center',
                        color: 'gray'
                    }}>
                        <Typography variant={'span'} style={{'marginRight': '10px'}}>
                            Записей на странице
                        </Typography>
                        <Select
                            type={'select'}
                            rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                            borderRadius={'20px 20px'}
                            width={'76px'}
                            onChange={this.handleChangeRowsPerPage}
                        />

                        {rowPerPage !== 'ВСЕ' && <Pagination
                            classes={{selected: classes.selectedPagin}}
                            count={Math.ceil(data.length / rowPerPage)}
                            color="primary"
                            page={page}
                            onChange={this.handleChangePage}
                            size={'large'}/>}
                    </Grid>
                </Grid>

                <ChangeWhitelistPopup
                    open={this.state.isOpenIdsPopup}
                    onChange={this.handleChangeIds}
                    value={this.state.changedIds}
                    onSuccess={this.saveIds}
                    onClose={() => this.setState({isOpenIdsPopup: false, changedSiteId: null, changedIds: null})}

                />
            </div>
        );
    }

}

export default withStyles(styles)(Whitelist)